import { render, staticRenderFns } from "./DetailsVisitor.vue?vue&type=template&id=781ce2c3&lang=pug&"
import script from "./DetailsVisitor.vue?vue&type=script&lang=js&"
export * from "./DetailsVisitor.vue?vue&type=script&lang=js&"
import style0 from "./DetailsVisitor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports